import React, { useState, useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import TabsComponent from '../../components/common/TabsComponent';
import GridCoursesCanvas from '../../components/templates/course/teacher/GridCoursesCanvas';
import GridCoursesTeacher from '../../components/templates/course/teacher/GridCoursesTeacher';
import { titleHTML } from '../../helpers/title.helper';
import useCoursesTeacher from '../../hooks/useCoursesTeacher';

const CourseTeacher = () => {
    titleHTML('Cursos');

    const { courses } = useCoursesTeacher();

    const professorSisId = useSelector(
        (state) => state?.auth?.user?.repositorio_data?.professor_sis_id
    );

    // useMemo para cachear los cursos filtrados
    const acropolisCourses = useMemo(
        () =>
            !!courses
                ? courses.filter(
                      (course) => course?.tipo_aula !== 'acropolis_lab'
                  )
                : null,
        [courses]
    );

    const acropolisLABCourses = useMemo(
        () =>
            !!courses
                ? courses.filter(
                      (course) => course?.tipo_aula === 'acropolis_lab'
                  )
                : null,
        [courses]
    );

    // useMemo para cachear las tabs
    const tabs = useMemo(() => {
        const tabsList = [{ label: 'Acrópolis', id: 0 }];

        if (acropolisLABCourses && acropolisLABCourses.length > 0) {
            tabsList.push({ label: 'Acrópolis LAB', id: 2 });
        }

        if (!!professorSisId) {
            tabsList.push({ label: 'Canvas', id: 1 });
        }

        return tabsList;
    }, [acropolisLABCourses, professorSisId]);

    const [tab, setTab] = useState(0);

    useEffect(() => {
        const tabExists = tabs.find((t) => t.id === tab);
        if (!tabExists) {
            setTab(0);
        }
    }, [tabs, tab]);

    const handleTab = (_, value) => {
        setTab(value);
    };

    const renderCase = (type) => {
        const caseType = {
            0: <GridCoursesTeacher filteredCourses={acropolisCourses} />,
            1: <GridCoursesCanvas />,
            2: <GridCoursesTeacher filteredCourses={acropolisLABCourses} />,
        };

        return caseType[type];
    };

    return (
        <>
            <CourseTeacherWrapper>
                <TabsComponent tab={tab} handleTab={handleTab} tabs={tabs} />
                <TabCase>{renderCase(tab)}</TabCase>
            </CourseTeacherWrapper>
        </>
    );
};

export default CourseTeacher;

const CourseTeacherWrapper = styled.div`
    display: flex;
    flex-direction: column;
    grid-area: banner;
    height: auto;
    border-radius: 2rem;
    background-color: #fff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    header {
        border-top-left-radius: 2rem;
        border-top-right-radius: 2rem;
    }
`;

const TabCase = styled.div`
    padding: 1rem;
`;
